import { render, staticRenderFns } from "./ApplicationDataLoadRedirect.vue?vue&type=template&id=4b3f57e6&"
import script from "./ApplicationDataLoadRedirect.vue?vue&type=script&lang=ts&"
export * from "./ApplicationDataLoadRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports